import axios from 'axios';
import auth from './auth';

async function intercept() {
  const apiHome: string = await axios
    .get('/api.json')
    .then(({ data }) => data.apihome);

  axios.interceptors.request.use(async (configuration) => {
    const request = { ...configuration };

    /**
     * Assets does not support custom HTTP headers.
     * api-t will block requests if you send a token to an open resource. in this case /api.json.
     */
    if (request?.url?.startsWith('/api') || request?.url?.includes('assets')) {
      return request;
    }

    request.headers.ClientId = 'document-archive-web';

    /**
     * if the request is an open one, then
     * prepend apiHome, but don't attach
     * token of any kind
     */
    if (request?.url?.startsWith('/open')) {
      request.url = `${apiHome}${request.url}`;

      return request;
    }

    /**
     * if request specifies an absolute path (starts with http),
     * then don't attach anything to it. Otherwise attach the
     * Bearer token and prepend apiHome to it!
     */
    if (!request?.url?.startsWith('http')) {
      const token = await auth.getToken();
      request.headers.Authorization = `Bearer ${token}`;
      request.url = `${apiHome}${request.url}`;

      return request;
    }

    return request;
  });
}

export default intercept;
